module.exports = __webpack_public_path__ + "media/fonts/Oricons-134a12285895c8e383b32cd8339334e4.woff";